import { Directive, ElementRef, inject, Input } from '@angular/core';

export type HighlightMessageTrayRole = 'primary' | 'secondary' | 'indicator' | 'label';

@Directive({
  selector: '[highlightMessageTray]',
  standalone: true
})
export class HighlightMessageTrayDirective {
  @Input('highlightMessageTray') role: HighlightMessageTrayRole | '' = 'primary';

  readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  get normalizedRole(): HighlightMessageTrayRole {
    return this.role || 'primary';
  }
}
